{
  "email": "Email",
  "showPassword": "Show password",
  "hidePassword": "Hide password",
  "welcomeText": "Capture, analyze and transform your company in days - not months.",
  "certDicisTitle": "Visit our compliance profile",
  "certDicisAlt": "ISO 9001 + 27001 certified company (DICIS)",
  "certDsgvoAlt": "GDPR compliant – Hosted in Europe",
  "certGobdAlt": "GoBD Ready",
  "dontHaveAccount": "Don't have an account",
  "contactCompany": "Contact BLIKS IO",
  "loading": "Loading...",
  "byContinueTermFull": "By continuing, you agree to BLIKS IO's <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
  "termOfService": "Terms of Service",
  "privacyPolicy": "Privacy Policy",
  "termsLanguageFallbackNotice": "The official version of these license terms is available in German and English. The English version is shown below.",
  "backToLogin": "Back to Login",
  "emailIsRequired": "Email is required",
  "loggingOut": "Signing you out...",
  "switchingWorkspace": "Switching workspace...",
  "ssoSigningIn": "Signing you in...",
  "ssoSignInFailed": "Sign-in failed",
  "selectWorkspaceDescription": "Choose which workspace to continue in",
  "selectWorkspaceCurrent": "Current workspace",
  "selectWorkspacePending": "Invited",
  "noWorkspaceForEmail": "No workspace was found for this email address. Check the address or contact your administrator."
}
